exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-auto .btn-row-container{display:flex;justify-content:center;align-items:center}.edit-auto .v-input.v-text-field--outline .v-input__slot{min-height:60px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/ModalEditTarga.vue?vue&type=style&index=0&lang=scss&
// module id = 834
// module chunks = 0